import React from "react";
import { Icons } from "../../components/common/Icons";
import { empSidebarItems } from "../../data/employeeData";
import { useEmployeeData } from "../../context/EmployeeContext";
import { AvatarDisplay } from "../../components/common/AvatarUpload";
import { usePermissions } from "../../hooks/usePermissions";import "../../assets/styles/Employee/EmpSidebar.css";

function EmpSidebar({ active, setActive, onLogout, user, offboardingOnly = false, sidebarOpen, setSidebarOpen }) {
  const { empInfo, empNotifications } = useEmployeeData();
  const notifUnread = (empNotifications || []).filter((n) => n.unread || !n.is_read).length;
  const chatUnread = (empNotifications || []).filter((n) => (n.unread || !n.is_read) && String(n.type || '').toLowerCase() === 'chat').length;
  const { canShowNav } = usePermissions();
  if (offboardingOnly) {
    const offItem = empSidebarItems.find((i) => i.key === 'offboarding');
    const OffIcon = offItem?.icon;
    return (
      <div
        className={`sidebar ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
        onMouseEnter={() => setSidebarOpen?.(true)}
        onMouseLeave={() => setSidebarOpen?.(false)}
      >
        <div className="sidebar-brand">
          <img src="/logo.png" alt="AMS" className="sidebar-logo empsidebar-inline-1" />
          <div><div className="sidebar-brand-text">AMSHRMS</div><div className="sidebar-brand-sub">Employee Portal</div></div>
        </div>
        <nav className="sidebar-nav">
          <div className="sidebar-section-label">Exit Process</div>
          {offItem && <div className={`sidebar-item ${active === offItem.key ? "active" : ""}`} onClick={() => setActive(offItem.key)}>{OffIcon ? <OffIcon /> : null}{offItem.label}</div>}
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <AvatarDisplay src={user?.avatar} name={empInfo.name || user?.name} size={36} />
            <div>
              <div className="sidebar-user-name">{empInfo.name || user?.name || 'Employee'}</div>
              <div className="sidebar-user-role">{empInfo.role || 'Employee'}</div>
            </div>
          </div>
          <button onClick={onLogout} className="empsidebar-inline-2">
            <Icons.Logout /> Sign Out
          </button>
        </div>
      </div>);

  }

  const main = empSidebarItems.slice(0, 3).filter((item) => canShowNav(item.key));
  const work = empSidebarItems.slice(3, 9).filter((item) => canShowNav(item.key));
  const connect = empSidebarItems.slice(9, 14).filter((item) => canShowNav(item.key));
  const more = empSidebarItems.slice(14).filter((item) => canShowNav(item.key));
  return (
    <div
      className={`sidebar ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      onMouseEnter={() => setSidebarOpen?.(true)}
      onMouseLeave={() => setSidebarOpen?.(false)}
    >
      <div className="sidebar-brand">
        <img src="/logo.png" alt="AMS" className="sidebar-logo empsidebar-inline-3" />
        <div><div className="sidebar-brand-text">AMSHRMS</div><div className="sidebar-brand-sub">Employee Portal</div></div>
      </div>
      <nav className="sidebar-nav">
        <div className="sidebar-section-label">Main</div>
        {main.map((item) =>
        <div key={item.key} className={`sidebar-item ${active === item.key ? "active" : ""}`} onClick={() => setActive(item.key)}><item.icon />{item.label}</div>
        )}
        <div className="sidebar-section-label">Work</div>
        {work.map((item) =>
        <div key={item.key} className={`sidebar-item ${active === item.key ? "active" : ""}`} onClick={() => setActive(item.key)}><item.icon />{item.label}</div>
        )}
        <div className="sidebar-section-label">Connect</div>
        {connect.map((item) =>
        <div key={item.key} className={`sidebar-item ${active === item.key ? "active" : ""}`} onClick={() => setActive(item.key)}>
            <item.icon />{item.label}
            {item.key === "announcements" && notifUnread > 0 && <span className="sidebar-badge">{notifUnread > 99 ? "99+" : notifUnread}</span>}
            {item.key === "chat" && chatUnread > 0 && <span className="sidebar-badge">{chatUnread > 99 ? "99+" : chatUnread}</span>}
          </div>
        )}
        <div className="sidebar-section-label">More</div>
        {more.map((item) =>
        <div key={item.key} className={`sidebar-item ${active === item.key ? "active" : ""}`} onClick={() => setActive(item.key)}><item.icon />{item.label}</div>
        )}
      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <AvatarDisplay src={user?.avatar} name={empInfo.name || user?.name} size={36} />
          <div>
            <div className="sidebar-user-name">{empInfo.name || user?.name || 'Employee'}</div>
            <div className="sidebar-user-role">{empInfo.role || 'Employee'}</div>
          </div>
        </div>
        <button onClick={onLogout} className="empsidebar-inline-4">
          <Icons.Logout /> Sign Out
        </button>
      </div>
    </div>);

}

export default EmpSidebar;
